<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M23 4L23 14C23 14.5523 22.5523 15 22 15L2 15C1.44772 15 1 14.5523 1 14L0.999999 4C0.999999 3.44772 1.44771 3 2 3L22 3C22.5523 3 23 3.44771 23 4Z" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M18 10L18 20C18 20.5523 17.5523 21 17 21L7 21C6.44771 21 6 20.5523 6 20L6 10C6 9.44772 6.44771 9 7 9L17 9C17.5523 9 18 9.44771 18 10Z" fill="#fff" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M20 9L4 9" :stroke="fill" stroke-linecap="round" stroke-width="2"/>
    <path d="M19 6L20 6" :stroke="fill" stroke-linecap="round" stroke-width="2"/>
    <path d="M15 18L9 18" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M14 15L10 15" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path d="M15 12L9 12" :stroke="fill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'Print',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
